<template>
  <div class="default-modal">
    <el-dialog
      width="70%"
      top="15vh"
      v-model="exportReportsDialogVisisble"
      @close="close"
    >
      <div class="export-dialog-header">
        <div class="export-header-part">
          <h3>CASE REPORT</h3>
        </div>

        <el-button
          size="medium"
          class="el-white"
          type="info"
          plain
          @click="close"
        >
          <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
        /></el-button>
      </div>
      <div
        class="selected-string"
        v-if="selected_case_type && selected_case_type.length"
      >
        <h3>
          Selected Case Type :
          <span
            class="value"
            v-for="(caseType, index) of getCaseTypes(selected_case_type)"
            :key="index"
            >{{ caseType }}<span v-if="index + 1 < selected_case_type.length">, </span>
          </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="
          selected_case_types &&
          Array.isArray(selected_case_types) &&
          selected_case_types.length
        "
      >
        <h3>
          Selected Case Type :
          <span
            class="value"
            v-for="(caseType, index) of getCaseTypes(selected_case_types)"
            :key="index"
            >{{ caseType }}
            <span v-if="index + 1 < selected_case_types.length">,</span>
          </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="priority === 'Stat' || priority === 'Routine'"
      >
        <h3>
          Priority:
          <span class="value">{{
            priority === "Stat" ? "STAT" : "Routine"
          }}</span>
        </h3>
      </div>
      <div class="selected-string" v-if="dateOfBirth && dateOfBirth.length">
        <h3>
          Selected DOB :
          <span class="value">{{ selectedDob(selected_dob) }} </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="selected_date_type && selected_date_type.length"
      >
        <h3>
          Selected Date Type :
          <span class="value">{{ getDateTypeMap(selected_date_type) }} </span>
        </h3>
      </div>
      <div class="selected-string" v-if="selected_from_date">
        <h3>
          Selected From Date :
          <span class="value">{{ selectedDob(selected_from_date) }} </span>
        </h3>
      </div>
      <div class="selected-string" v-if="selected_to_date">
        <h3>
          Selected To Date :
          <span class="value">{{ selectedDob(selected_to_date) }} </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="search_first_name && search_first_name.length"
      >
        <h3>
          Search Patient Name :
          <span class="value">{{ search_first_name }} </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="search_last_name && search_last_name.length"
      >
        <h3>
          Search Last Name :
          <span class="value">{{ search_last_name }} </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="search_case_statuses && search_case_statuses.length"
      >
        <h3>
          Selected Status :
          <span class="value" v-if="search_case_statuses == 'COMPLETE'"
            >{{ getStatusType(search_case_statuses) }}
          </span>

          <span class="value" v-else
            >{{ getStatusType(search_case_statuses) }}
          </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="selected_covid_status && selected_covid_status.length"
      >
        <h3>
          Selected Covid Status :
          <span class="value">{{ selected_covid_status }}</span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="
          search_case_status &&
          Array.isArray(search_case_status) &&
          search_case_status.length
        "
      >
        <h3>
          Selected Status :
          <span
            class="value"
            v-for="(caseStatus, index) of getStatusMap(search_case_status)"
            :key="index"
            >{{ caseStatus }}
            <span v-if="index + 1 < search_case_status.length">,</span>
          </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="selected_hospital && selected_hospital.filter(Boolean).length > 0"
      >
        <h3>
          Selected Ordering Facility :
          <span class="value"
            >{{ getSelectedHospital(selected_hospital) }}
          </span>
        </h3>
      </div>
      <div class="selected-string" v-if="selected_user && selected_user.length">
        <h3>
          Selected Assigned to :
          <span class="value">{{ getSelectedUser(selected_user) }} </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="
          selected_marketer &&
          Array.isArray(selected_marketer) &&
          selected_marketer.length
        "
      >
        <h3>
          Selected Marketer :
          <span
            class="value"
            v-for="(marketer, index) of selected_marketer"
            :key="index"
            >{{ getSelectedUser(marketer) }}
          </span>
        </h3>
      </div>

      <div
        class="selected-string"
        v-if="selected_physician && selected_physician.length"
      >
        <h3>
          Selected Physician :
          <span class="value"
            >{{ getSelectedPhysician(selected_physician) }}
          </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="selected_string && selected_string.length"
      >
        <h3>
          Selected String :
          <span class="value">{{ selected_string }} </span>
        </h3>
      </div>
      <div>
        <div
          class="selected-string"
          v-if="
            search_billed_status &&
            (search_billed_status.includes('Unbilled') ||
              search_billed_status.includes('PENDING'))
          "
        >
          <h3>
            Selected Billed Status :
            <span
              class="value"
              v-for="(biling, index) in search_billed_status"
              :key="index"
              >{{ biling }}
            </span>
          </h3>
        </div>
        <div
          v-if="
            search_billed_status &&
            [
              'Billed',
              'Billed with Exception',
              'Client',
              'Coding',
              'Exception',
              'On hold',
              'Patient',
              'Exception Reviewed',
            ].includes(search_billed_status)
          "
          class="selected-string"
        >
          <h3>
            Selected Billed Status :
            <span class="value">{{ search_billed_status }}</span>
          </h3>
        </div>
      </div>

      <div class="selected-string" v-if="selected_emr && selected_emr.length">
        >
        <h3>
          Selected EMR :
          <span class="value">{{ selected_emr }} </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="selected_accession_id && selected_accession_id.length"
      >
        <h3>
          Selected Barcode :
          <span class="value">{{ selected_accession_id }} </span>
        </h3>
      </div>
      <div class="selected-string" v-if="selected_billing_assigne && selected_billing_assigne.length">
        <h3>
          Selected Billing Assigne :
          <span class="value"
            >{{ getSelectedBillingUser(selected_billing_assigne) }}
          </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="search_billed_sub_status && search_billed_sub_status.length"
      >
        <h3>
          Selected Billing Sub Status :
          <span class="value">{{ search_billed_sub_status }} </span>
        </h3>
      </div>
      <div class="dialog-body">
        <div class="export-popup-body" v-loading="loading">
          <div class="select-fields">
            <el-checkbox-group v-model="activeFieldList">
              <ul class="select-fields-list">
                <li
                  class="search-checkbox"
                  v-for="(item, index) in casesExportFields"
                  :key="index"
                >
                  <el-checkbox :label="item.value">
                    {{ item.label }}
                  </el-checkbox>
                </li>
              </ul>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <div class="dialog-footer export-footer w-95">
        <el-button
          class="cancel-button"
          @click="handleClear"
          :disabled="!this.activeFieldList.length"
          >CLEAR ALL</el-button
        >
        <el-button class="cancel-button" @click="handleCheckAllChange"
          >SELECT ALL</el-button
        >
        <el-button class="cancel-button" @click="close">CANCEL</el-button>
        <el-button
          class="blue-save-button"
          @click="downloadAmendedCases"
          v-if="selected_date_type == 'amended_date'"
        >
          DOWNLOAD
        </el-button>
        <el-button class="blue-save-button" @click="downloadCases(false)" v-else>
          DOWNLOAD
        </el-button>
        <el-button class="blue-save-button" @click="downloadCases(true)">
          Download All Labs
        </el-button>
        <el-dropdown
          v-if="
            !isBillingUser &&
            ['collection_date', 'received_date', 'finalized_date'].includes(
              selected_date_type
            )
          "
          trigger="click"
          @command="(w) => emailExport(w, true)"
          :disabled="emailExportLoading"
        >
          <el-button class="blue-save-button" :loading="emailExportLoading">
            Email Export All Labs<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="last_day">Last Day</el-dropdown-item>
              <el-dropdown-item command="last_week">Last Week</el-dropdown-item>
              <!-- <el-dropdown-item command="last_month">Last Month</el-dropdown-item> -->
              <!-- <el-dropdown-item command="last_2_months">Last 2 Months</el-dropdown-item> -->
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import AppHelper from "@/mixins/AppHelper";
import exportExcelHelper from "@/mixins/exportExcelHelper";
import FilterHelper from "@/mixins/FilterHelper";
import GlobalHelper from "@/mixins/GlobalHelper";
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
import moment from "moment";
export default {
  mixins: [
    UserPermissionsHelper,
    exportExcelHelper,
    caseDataHelper,
    AppHelper,
    FilterHelper,
    GlobalHelper,
  ],
  props: [
    "selected_dob",
    "selected_case_type",
    "selected_hospital",
    "selected_hospital_names",
    "selected_user",
    "selected_marketer",
    "selected_physician",
    "selected_string",
    "selected_emr",
    "selected_accession_id",
    "search_case_status",
    "selected_from_date",
    "selected_to_date",
    "search_first_name",
    "search_last_name",
    "selected_date_type",
    "selected_case_types",
    "search_case_statuses",
    "selected_covid_status",
    "selected_tests",
    "pregnancy",
    "search_billed_status",
    "selected_billing_assigne",
    "sendout",
    "inhouse",
    "cross_lab_registered",
    "emr_not_sent",
    "selected_exception",
    "search_billed_sub_status",
    "replaced_insurance",
    "priority",
    "fromDate",
    "toDate",
    "tat_colour",
    "selectedPlatform",
    "selectedFaxFlag",
    "tatNotCrossedFlag",
    "selectedReportStatus",
    "issues",
    "release",
    "isStatSort",
  ],
  computed: {
    mappedSelectedOptions() {
      return this.activeFieldList.map((option) => {
        return this.exportExtraCasesExcelFields.find(
          (opt) => opt.value === option
        );
      });
    },
    ...mapGetters("cases", [
      "getAllCases",
      "getCaseDeleteStatus",
      "getCaseDeleteError",
      "getUpdateCaseStatus",
      "getAllCaseErrors",
      "getUpdateCaseCovidStatus",
      "getDownloadCaseDataStatus",
    ]),

    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("userAccounts", ["getAllUsers"]),
    ...mapGetters("labTests", [
      "getAllLabTests",
      "getNewLabGroupWiseTests",
      "getNewLabGroupPanelTests",
      "getNewLabGroupWiseTestsData",
    ]),
    ...mapGetters("auth", [
      "getAuthenticatedUser",
      "getUserAllowedLabs",
      "getUserLabDetails",
    ]),

    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "Active";
        } else if (status == "COMPLETE") {
          return "Finalized";
        } else if (status == "TEST_REPORTS") {
          return "PROCESSING";
        } else if (status == "REJECTED") {
          return "Rejected";
        } else if (status == "PENDING") {
          return "Pending";
        } else if (status == "TO_BE_COLLECTED") {
          return "Future";
        } else {
          return "";
        }
      };
    },
    getCaseTypeMap() {
      return (status) => this.caseTypeMap[status];
    },
    getDateTypeMap() {
      return (date) => this.dateTypeMap[date];
    },
    getStatusMap() {
      return (status) => {
        return (status || []).map((e) => this.statusMap[e]);
      };
    },
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
    selectedDob() {
      return (selected_dob) => moment(selected_dob).format("MM-DD-YYYY");
    },
  },
  data() {
    return {
      exportReportsDialogVisisble: true,
      fieldList: [],
      activeFieldList: [],
      checkAll: true,
      loading: false,
      emailExportLoading: false,
      date_type: "",
      status: "",
      statusMap: caseConstants.STATUS_TYPE_MAP,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      caseTypes: caseConstants.CASE_TYPES_DATA,
      dateTypeMap: {
        created_at: "Created",
        collection_date: "Collection",
        received_date: "Received",
        finalized_date: "Reported",
        amended_date: "Amended",
        billing_application_sent_on: "Rxnt Sent On",
      },
      dateOfBirth: "",

      roleGroups: {
        labUsers: [
          "LAB_ADMIN",
          "LAB_SUPER_ADMIN",
          "LAB_TECHNOLOGIST",
          "LAB_DATA_ASSISTANT",
          "ADMIN",
          "LAB_MANAGER",
          "LAB_DATA_ADMIN",
          "QC_MANAGER",
        ],
        billingUsers: [
          "BILLING_REPRESENTATIVE",
          "AR_LEAD",
          "AR_EXECUTIVE",
          "CP_LEAD",
          "CODING_LEAD",
          "CODING_EXECUTIVE",
          "POSTING_EXECUTIVE",
          "SR_FTE",
        ],
        clientSalesUsers: [
          "ACCOUNT_MANAGER",
          "SALES_DIRECTOR",
          "HOSPITAL_MARKETING_MANAGER",
          "MARKETER",
          "REGIONAL_DIRECTOR",
          "SALES_SUPPORT_TEAM",
        ],
      },
      casesExportFields: [],
    };
  },
  created() {
    const userRole = this.getCurrentUser(); // Get the current user's role
    let userGroup;
    if (this.roleGroups.labUsers.includes(userRole)) {
      userGroup = "labUsers";
    } else if (this.roleGroups.billingUsers.includes(userRole)) {
      userGroup = "billingUsers";
    } else if (this.roleGroups.clientSalesUsers.includes(userRole)) {
      userGroup = "clientSalesUsers";
    }
    const fieldGroup = userGroup === "clientSalesUsers" ? "labUsers" : userGroup;
    const accessibleFields = this.groupBasedFields[fieldGroup] || [];
    this.casesExportFields = [];

    // Filter exportExtraCasesExcelFields based on accessible fields
    this.exportExtraCasesExcelFields.forEach((obj) => {
      if (accessibleFields.includes(obj.value)) {
        this.casesExportFields.push(obj);
      }
    });
    this.activeFieldList = this.defaultExportCasesExcelFields
      .filter((field) => accessibleFields.includes(field.value))
      .map((field) => field.value);

    // Hide TAT field for Chantilly lab users
    if (this.isChantillyLab) {
      this.casesExportFields = this.casesExportFields.filter(
        (field) => field.value !== "TAT"
      );
      this.activeFieldList = this.activeFieldList.filter(
        (value) => value !== "TAT"
      );
    }
  },
  async mounted() {
    this.loading = true;
    this.status = this.search_case_status;
    if (this.selected_dob) {
      this.dateOfBirth = this.selectedDob(this.selected_dob);
    }
    this.loading = false;
  },
  methods: {
    shouldIncludeFieldForSelectedBucket(field) {
      if (field !== "active_insurance") {
        return true;
      }
      return this.shouldShowActiveInsuranceWithPolicyField;
    },
    getCurrentUser() {
      return this.getAuthenticatedUser.user_type;
    },
    handleClear() {
      this.activeFieldList = [];
      this.fieldList = [];
    },
    getSelectedHospital(hospitalId) {
      // Prefer names passed from the parent: the hospitals store only holds the
      // most recently searched facilities, so resolving names from it drops any
      // selected hospital that isn't in the latest search results.
      if (this.selected_hospital_names && this.selected_hospital_names.length) {
        return this.selected_hospital_names.join(", ");
      }
      const hospitals =
        this.getAllHospitals && Array.isArray(this.getAllHospitals.data)
          ? this.getAllHospitals.data
          : [];
      return hospitals
        .filter((hospital) => hospitalId.indexOf(hospital._id) != -1)
        .flatMap((hospital) => hospital.name)
        .join(", ");
    },
    getSelectedPhysician(physicianId) {
      const ids = Array.isArray(physicianId) ? physicianId : [physicianId];
      const physicians =
        this.getAllPhysicians && Array.isArray(this.getAllPhysicians.data)
          ? this.getAllPhysicians.data
          : [];
      return physicians
        .filter((physician) => ids.indexOf(physician._id) != -1)
        .flatMap((physician) => physician.name)
        .join(", ");
    },
    getSelectedTest(tests) {
      const labTests = Array.isArray(this.getAllLabTests)
        ? this.getAllLabTests
        : [];
      return labTests
        .filter((test) => tests.indexOf(test._id) != -1)
        .flatMap((test) => test.name)
        .join(", ");
    },
    getSelectedUser(userId) {
      const users =
        this.getAllUsers && Array.isArray(this.getAllUsers.data)
          ? this.getAllUsers.data
          : [];
      return users
        .filter((user) => userId.indexOf(user._id) != -1)
        .flatMap((user) => user.first_name + " " + user.last_name)
        .join(", ");
    },
    getSelectedBillingUser(billingId) {
      const users =
        this.getAllUsers && Array.isArray(this.getAllUsers.data)
          ? this.getAllUsers.data
          : [];
      return users
        .filter((user) => billingId.indexOf(user._id) != -1)
        .flatMap((user) => user.first_name + " " + user.last_name)
        .join(", ");
    },
    prepareParams() {
      if (this.activeFieldList.length) {
        let params = {
          include: this.activeFieldList,
        };

        if (this.date_type) {
          params.date_type = this.date_type;
        }

        if (
          this.search_case_status &&
          Array.isArray(this.search_case_status) &&
          this.search_case_status.length > 1
        ) {
          params.case_status = this.search_case_status;
        } else if (this.search_case_status && this.search_case_status.length) {
          params.status = this.search_case_status.toString();
        } else if (Object.keys(params).indexOf("status") != -1) {
          delete params.status;
        }
        if (this.search_case_statuses) {
          params.status = this.search_case_statuses;
        }
        if (this.selected_string) {
          params.search_string = this.selected_string;
        }
        if (
          this.search_billed_status &&
          (this.search_billed_status.includes("Unbilled") ||
            this.search_billed_status.includes("PENDING"))
        ) {
          params.billing_status = this.search_billed_status;
        } else if (
          this.search_billed_status &&
          (this.search_billed_status.includes("Billed") ||
            this.search_billed_status.includes("Billed with Exception") ||
            this.search_billed_status.includes("Client") ||
            this.search_billed_status.includes("Coding") ||
            this.search_billed_status.includes("Exception") ||
            this.search_billed_status.includes("On hold") ||
            this.search_billed_status.includes("Patient"))
        ) {
          params.billing_status = [this.search_billed_status];
        }

        if (this.selected_emr) {
          params.emr = this.selected_emr;
        }
        if (this.selected_accession_id) {
          params.accession_id = this.selected_accession_id;
        }
        if (this.selected_case_type && this.selected_case_type.length) {
          params.case_types = [].concat(this.selected_case_type);
        }
        if (this.selected_case_types && this.selected_case_types.length) {
          params.case_types = this.selected_case_types;
        }
        if (this.selected_hospital != "") {
          params.hospitals = this.selected_hospital;
        }
        if (this.selected_user && this.selected_user.length) {
          params.test_performed_by = this.selected_user;
        }
        if (this.selected_marketer && this.selected_marketer.length) {
          params.hospital_marketers = this.selected_marketer;
        }
        if (this.selected_tests && this.selected_tests.length) {
          params.tests_info = [].concat.apply([], this.selected_tests);
        }
        if (this.selected_physician && this.selected_physician.length) {
          params.ordering_physician = this.selected_physician;
        }
        if (this.search_first_name) {
          params.patient_name = this.search_first_name;
        }
        if (this.search_last_name) {
          params.last_name = this.search_last_name;
        }
        if (this.selected_covid_status) {
          params.covid_status = this.selected_covid_status;
        }

        if (this.selected_dob) {
          const patient_dob = moment(this.selected_dob).format("YYYY-MM-DD");

          params.date_of_birth = patient_dob;
        }
        if (this.selected_from_date) {
          const slected_date = this.convertToLabUTC(this.selected_from_date);

          params.from_date = slected_date;
        }
        if (this.selected_to_date) {
          const selected_end_date = this.convertToLabUTC(
            this.selected_to_date,
            true
          );
          params.to_date = selected_end_date;
        }
        if (this.pregnancy) {
          params.pregnant = this.pregnancy;
        }
        if (this.selected_billing_assigne && this.selected_billing_assigne.length) {
          params.billing_representative = this.selected_billing_assigne;
        }
        if (this.sendout) {
          params.is_sendout = this.sendout;
        }
        if (this.inhouse) {
          params.is_inhouse = true;
        }
        // "Only Houston Cases" filter from the list — YES sends false, NO true.
        if (this.cross_lab_registered === true || this.cross_lab_registered === false) {
          params.is_cross_lab_registered = this.cross_lab_registered;
        }
        if (this.selectedPlatform && this.selectedPlatform.length) {
          params.testgo_order_type = this.selectedPlatform;
        }
        if (this.selectedFaxFlag) {
          params.fax_bidirectional = this.selectedFaxFlag;
        }
        if (this.tatNotCrossedFlag) {
          params.tat_crossed = this.tatNotCrossedFlag;
        }
        if (this.selectedReportStatus) {
          params.is_new_report = this.selectedReportStatus;
        }
        if (this.issues) {
          params.issues = true;
        }
        if (this.release === true || this.release === false) {
          params.release = this.release;
        }
        if (this.emr_not_sent) {
          params.emr_result_not_sent = this.emr_not_sent;
        }
        if (this.selected_exception && this.selected_exception.length) {
          params.billing_sub_status = this.selected_exception;
        }
        if (this.search_billed_sub_status) {
          params.billing_sub_status = this.search_billed_sub_status;
        }
        if (this.replaced_insurance) {
          params.replaced_insurance = this.replaced_insurance;
        }
        if (this.priority == "Stat") {
          params.is_stat = true;
        }
        if (this.priority == "Routine") {
          params.is_stat = false;
        }
        if (this.fromDate) {
          params.from_date = this.fromDate;
        }
        if (this.toDate) {
          params.to_date = this.toDate;
        }
        if (this.isStatSort == true) {
          params.order_by = "is_stat";
          params.order_type = "desc";
        }
        if (this.tat_colour && this.tat_colour.length) {
          params.tat_colour = this.tat_colour;
        }
        if (this.isGowthamUser) {
          params.is_old = true;
        }
        if (
          this.search_billed_status &&
          (this.search_billed_status.includes("Exception") ||
            this.search_billed_status.includes("Exception Reviewed")) &&
          !this.isBillingUser
        ) {
          params.billing_status = [
            "Exception",
            "Exception Reviewed",
            "exception reviewed",
          ];
          params.is_both_lab = true;
        }
        return params;
      }
    },

    async downloadAmendedCases() {
      if (this.activeFieldList.length) {
        let params = this.prepareParams();
        if (this.selected_date_type) {
          params.date_type = "amendement_details.amendment_time";
        }
        this.loading = true;
        await this.$store.dispatch("cases/downloadCaseData", params);
        this.loading = false;
        if (this.getDownloadCaseDataStatus) {
          this.close();
        } else {
          this.$message({
            message: "Error in downloading cases / maximum limit exceeded",
            type: "error",
          });
        }
      } else {
        this.$message({
          message: "Please select the data fields.",
          type: "warning",
        });
      }
    },
    async downloadCases(isBothLabs = false) {
      if (this.activeFieldList.length) {
        let params = this.prepareParams();
        if (this.selected_date_type) {
          params.date_type = this.selected_date_type;
        }
        if (isBothLabs) {
         params.is_both_lab = true;
        }
        this.loading = true;
        await this.$store.dispatch("cases/downloadCaseData", params);
        this.loading = false;
        if (this.getDownloadCaseDataStatus) {
          this.close();
        } else {
          this.$message({
            message: "Error in downloading cases",
            type: "error",
          });
        }
      } else {
        this.$message({
          message: "Please select the data fields.",
          type: "warning",
        });
      }
    },
    // Request a precomputed export for a rolling window; server emails a link.
    // allLabs=true requests the cross-lab union file. Field selection / filters
    // in this modal do not apply — the export uses your role's standard columns.
    async emailExport(window, allLabs = false) {
      if (this.emailExportLoading) return;
      try {
        this.emailExportLoading = true;
        const result = await this.$store.dispatch(
          "cases/requestPrecomputedExport",
          {
            window,
            all_labs: allLabs,
            date_type: this.selected_date_type || "finalized_date",
          }
        );
        const notReady = result && result.ready === false;
        this.$message({
          message: notReady
            ? result.message ||
              "This export is being prepared overnight. Please try again later or use Download."
            : (result && result.message) ||
              "Your export is being emailed to you.",
          type: notReady ? "warning" : "success",
        });
      } catch (error) {
        this.$message({
          message:
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            "Unable to request export. Please try again.",
          type: "error",
        });
      } finally {
        this.emailExportLoading = false;
      }
    },
    close() {
      this.$emit("close");
    },
    handleCheckAllChange() {
      this.activeFieldList = [];
      this.fieldList = [];
      this.casesExportFields.forEach((obj) => {
        this.fieldList.push(obj.value);
      });
      this.activeFieldList = this.fieldList;
    },
  },
};
</script>
<style lang="scss">
.select-fields {
  ul {
    -webkit-column-count: 3;
    column-count: 3;
    -webkit-column-gap: 20px;
    column-gap: 20px;
    li {
      &:not(:last-child) {
        margin-bottom: 5px;
      }
    }
  }
}
</style>